export type Pt = readonly [number, number];

/** Oppervlak van een polygoon (genormaliseerde coördinaten). */
export function polyArea(p: readonly Pt[]): number {
  let a = 0;
  for (let k = 0; k < p.length; k++) {
    const [x1, y1] = p[k]!;
    const [x2, y2] = p[(k + 1) % p.length]!;
    a += x1 * y2 - x2 * y1;
  }
  return Math.abs(a) / 2;
}

export function inPoly(x: number, y: number, p: readonly Pt[]): boolean {
  let c = false;
  for (let i = 0, j = p.length - 1; i < p.length; j = i++) {
    const [xi, yi] = p[i]!;
    const [xj, yj] = p[j]!;
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi || 1e-9) + xi) c = !c;
  }
  return c;
}

export function polyCenter(p: readonly Pt[]): [number, number] {
  let x = 0;
  let y = 0;
  p.forEach((q) => {
    x += q[0];
    y += q[1];
  });
  return [x / p.length, y / p.length];
}

/** Rechthoek [x, y, w, h] als polygoon met 4 punten. */
export function rectToPoly([x, y, w, h]: readonly [number, number, number, number]): [number, number][] {
  return [
    [x, y],
    [x + w, y],
    [x + w, y + h],
    [x, y + h],
  ];
}

/** Ruimte op deze plek; bij overlap wint het kleinste vlak (bv. kast in een kantoor). */
export function roomAt<R extends { id: string; shape: { points: Pt[] } | null }>(
  rooms: readonly R[],
  x: number,
  y: number,
): R | null {
  const hits = rooms
    .filter((r) => r.shape && inPoly(x, y, r.shape.points))
    .sort((a, b) => polyArea(a.shape!.points) - polyArea(b.shape!.points));
  return hits[0] ?? null;
}

/** Minimale grootte van een ingetekend vlak (zoals in het prototype). */
export const MIN_ROOM_AREA = 0.0004;
